import { Skeleton } from '@/components/ui/skeleton'
import { TemplateCardFallback } from '@/routes/templates/template-card/fallback'

const PAGE_SIZE = 12

export const TemplateCardsFallback = () => {
  return (
    <>
      <div className="grid grid-cols-[repeat(auto-fill,_minmax(250px,_1fr))] gap-4">
        {new Array(PAGE_SIZE).fill(null).map((_, index) => (
          <TemplateCardFallback key={index} />
        ))}
      </div>
      <div className="flex items-center justify-end gap-2">
        <Skeleton className="size-8 rounded-md" />
        <Skeleton className="size-8 rounded-md" />
      </div>
    </>
  )
}
